import React, { useState } from 'react'
import Main from '../../cpn/Main'
import { Button, Form, Input, message } from 'antd'
import { useQiyeTypeAddMutation } from '../../store/dianshangtaizhangApi';
import TradeSelect from '../trade/TradeSelect';

function FirmTypeAdd() {
    const [form] = Form.useForm(); 
    const [submit] = useQiyeTypeAddMutation();
    const [info,setInfo] = useState()
    return (
        <Main selectedKeys={['/FirmTypeAdd']}>
            <Form
                form={form}
                layout="horizonal"
                name="form_client"
                initialValues={{modifier: 'public',}}
                labelCol={{ span: 3 }}   
                onFinish={() => {
                    submit({
                        "qyt_hyt_id" : info.qyt_hyt_id,
                        "qyt_hyt_name" : info.qyt_hyt_name,
                        "qyt_name" : info.qyt_name,
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                            
                            message.success('新增成功！')   
                            form.resetFields();                          
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    }) 
                }}                 
            >                                                       
                <TradeSelect
                    label="行业"                        
                    onChange={(e,f) => {
                        setInfo(prevState=>({...prevState,qyt_hyt_id:e,qyt_hyt_name:f}))
                    }}
                    wrapperCol={{span:10}}
                    required

                />
                <Form.Item name="name" wrapperCol={{span:10}} required label='企业类型'>                        
                    <Input onChange={(e) => {
                        setInfo(prevState=>({...prevState,qyt_name:e.target.value}))
                    }}/>
                </Form.Item>                       
                <Form.Item wrapperCol={{offset:3}} >                        
                    <Button type='primary' htmlType='submit'>提交</Button>
                </Form.Item>
            </Form>
        </Main>
    )
}

export default FirmTypeAdd